import type { BrowserRadioProfile } from './radio-web.ts'

export type WebProgrammerRoadmapRadio = {
  vendor: string
  model: string
  aliases?: readonly string[]
  note: string
}

export const WEB_PROGRAMMER_ROADMAP: readonly WebProgrammerRoadmapRadio[] = [
  {
    vendor: 'Kenwood',
    model: 'TS-2000',
    note: 'Desktop CAT supported; browser driver next',
  },
  {
    vendor: 'Retevis',
    model: 'RT97L',
    aliases: ['RT-97L'],
    note: 'Experimental desktop driver',
  },
  {
    vendor: 'Radtel',
    model: 'RT-950',
    aliases: ['RT950'],
    note: 'Experimental desktop driver',
  },
  { vendor: 'Yaesu', model: 'FT-857', note: 'Clone protocol next' },
  {
    vendor: 'Yaesu',
    model: 'FT-897',
    aliases: ['FT-857/897'],
    note: 'Clone protocol next',
  },
]

function normalizeModel(value: string): string {
  return value
    .toLowerCase()
    .replace(/\s*\(experimental\)\s*$/, '')
    .replace(/\s*\*$/, '')
    .replace(/[\s/_-]+/g, '')
}

function profileModels(profile: Pick<BrowserRadioProfile, 'model'>): string[] {
  return profile.model
    .split(/\s*[/|]\s*|\s+or\s+/i)
    .map(normalizeModel)
    .filter(Boolean)
}

export function pendingWebProgrammerRadios(
  profiles: readonly Pick<BrowserRadioProfile, 'vendor' | 'model'>[],
  roadmap: readonly WebProgrammerRoadmapRadio[] = WEB_PROGRAMMER_ROADMAP,
): WebProgrammerRoadmapRadio[] {
  return roadmap.filter((radio) => {
    const candidateNames = [radio.model, ...(radio.aliases ?? [])].map(
      normalizeModel,
    )
    return !profiles.some(
      (profile) =>
        profile.vendor.toLowerCase() === radio.vendor.toLowerCase() &&
        profileModels(profile).some((model) => candidateNames.includes(model)),
    )
  })
}
